import { apiFetch } from './client';

export interface ProfileAddress {
  street: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  interno?: string;
}

export interface ProfileDTO {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
  codiceFiscale: string;
  address: ProfileAddress;
}

export interface ProfileUpdatePayload {
  phoneNumber?: string;
  address?: Partial<ProfileAddress>;
}

export function getMyProfile(): Promise<ProfileDTO> {
  return apiFetch<ProfileDTO>('/espo/me');
}

export function updateMyProfile(payload: ProfileUpdatePayload): Promise<ProfileDTO> {
  return apiFetch<ProfileDTO>('/espo/me', {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}
